import React from 'react';
import { ChevronRight, House } from 'lucide-react';
import { appLinkClick } from '../utils/appRoutes';
import './Breadcrumbs.css';

export interface BreadcrumbItem {
  label: string;
  /** Renders the item as a link; without onClick the browser follows it. */
  href?: string;
  onClick?: () => void;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  homeLabel: string;
  navigationLabel: string;
  onNavigateHome: () => void;
  className?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  items,
  homeLabel,
  navigationLabel,
  onNavigateHome,
  className = ''
}) => (
  <nav className={`app-breadcrumbs ${className}`.trim()} aria-label={navigationLabel}>
    <ol className="app-breadcrumbs-list">
      <li className="app-breadcrumbs-home-item">
        <a
          href="/"
          className="app-breadcrumbs-home"
          onClick={appLinkClick(onNavigateHome)}
          aria-label={homeLabel}
          title={homeLabel}
        >
          <House size={14} strokeWidth={2} aria-hidden="true" />
        </a>
      </li>

      {items.map((item, index) => {
        const isCurrent = index === items.length - 1;

        return (
          <React.Fragment key={`${item.label}-${index}`}>
            <li className="app-breadcrumbs-separator" aria-hidden="true">
              <ChevronRight size={13} strokeWidth={2} />
            </li>
            <li className={`app-breadcrumbs-item ${isCurrent ? 'app-breadcrumbs-current-item' : ''}`}>
              {item.href && !isCurrent ? (
                <a
                  className="app-breadcrumbs-link"
                  href={item.href}
                  onClick={item.onClick && appLinkClick(item.onClick)}
                  title={item.label}
                >
                  {item.label}
                </a>
              ) : item.onClick && !isCurrent ? (
                <button
                  type="button"
                  className="app-breadcrumbs-link"
                  onClick={item.onClick}
                  title={item.label}
                >
                  {item.label}
                </button>
              ) : (
                <span
                  className="app-breadcrumbs-current"
                  aria-current={isCurrent ? 'page' : undefined}
                  title={item.label}
                >
                  {item.label}
                </span>
              )}
            </li>
          </React.Fragment>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumbs;
